export default __webpack_public_path__ + "static/media/codeclan-icon.73a331cd.jpeg";